import { CheckIcon, CloseIcon, HashtagIcon } from '../../../assets/svgs/icons';
import styles from './styles.module.css';

export const StepsList = ({ steps, children, title }) => {
  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      <ul className={styles.listContainer}>
        {steps?.map((step, index) => (
          <li key={index} className={`${styles.listItem} ${styles[step.status || 'idle']}`}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <HashtagIcon color={step.status === 'complete' ? '#005803' : '#626262'} size='24' />
              <p style={{ color: 'rgba(0, 0, 0, 0.5)' }}>
                {step.text}
              </p>
            </div>
            {step.status === 'complete' && <CheckIcon color='#005803' size='14' />}
            {step.status === 'error' && <CloseIcon color='red' size='20' />}
            {step.status === 'pending' && (
              <div className={styles.semicircle}></div>
            )}

          </li>
        ))}
      </ul>
      {children}
    </div>
  );
}